import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class LienService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getByRelatedAccount(accountId: number, generalLedgerId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `lien/related/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    
    getAllRelatedAccount(accountId: number, generalLedgerId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `lien/related/customer/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    getAllLienDetails(accountId: number, generalLedgerId: number,applicationModuleId:number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `lien/related/accountstatement/${accountId}?generalLedgerId=${generalLedgerId}&&applicationModuleId=${applicationModuleId}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    lienAmounrRemove(lienDetails: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'lien/lienRelease', lienDetails).pipe(
          map((res: Response) => res),
          catchError((err: any) => observableThrowError(err.message || 'Server error')));
      }

}